module.exports = __webpack_public_path__ + "img/IMG_9543_L_Black_MockedUp.32bc7075.jpg";